import React, { useContext, useState, useEffect, createContext } from 'react';
import { backendUrl } from '../App';   

// // ===================================== Spinner Modal Window Component =====================================
export const jsxElement_spinnerModalWindow = (isActive: boolean, msgText: string) => {
    return (
    <div
        className={`modal fade ${isActive ? "show d-block" : ""}`}
        tabIndex={-1}
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
        <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content text-center p-4">
            <div className="modal-body">
            <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Processing...</span>
            </div>
            <div>{msgText}</div>
            </div>
        </div>
        </div>
    </div>
    );
};

// ===================================== AlertMsg Component =====================================
// This component can be used in any part of your application where you need to show alert messages 
export type AlertMsgPropsType = {
  isActive?: boolean;
  message?: string;
  onClose?: () => void;
};

export const defaultAlertMsgProps: Required<AlertMsgPropsType> = {
  isActive: false,
  message: '',
  onClose: () => {},
};

// Context type for alert message status and setter
type AlertMsgStatusContextType = {
  alertMsgStatus: AlertMsgPropsType;
  setAlertMsgStatus: React.Dispatch<React.SetStateAction<AlertMsgPropsType>>;
};

// Create context (should be exported and created in a shared file in real projects)
export const AlertMsgStatusContext = React.createContext<AlertMsgStatusContextType>({
  alertMsgStatus: defaultAlertMsgProps,
  setAlertMsgStatus: () => {},
});

export const useAlertMsgStatus = () => useContext(AlertMsgStatusContext);

export const AlertMsgPopUp = ({ isActive, message }: AlertMsgPropsType) => {
  //console.log('AlertMsgPopUp useEffect triggered 0 isActive', isActive);
  const [isVisible, setIsVisible] = useState<boolean | undefined>(isActive);
  //console.log('AlertMsgPopUp useEffect triggered 1', isVisible);
  
  useEffect(() => {
    setIsVisible(isActive);
  }, [isActive])

  // Hide the saving alert automatically in 10 seconds
  useEffect(() => {
    if (isVisible) {
    const timer = setTimeout(() => {
        setIsVisible(false);     // Hide the alert after 10 seconds
    }, 10000);                                                  // 10,000 milliseconds = 10 seconds

    return () => clearTimeout(timer);                           // Cleanup if the component re-renders early
    }
  }, [isVisible]);

  if (isVisible) { 

    return (
        <div className="alert alert-success alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-1 w-75" role="alert" style={{ zIndex: 1050 }}>
        {message}
        <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
            onClick={() => setIsVisible(false)}
        ></button>
        </div>
    );

 } else  return null; // Return null if not active

};

// ===================================== Get a web page texts =====================================
export interface TranslationsType { [key: string]: string };

export const PageTextsDataContext = createContext<TranslationsType | null>(null);
export const usePageTextsData = () => useContext(PageTextsDataContext);

// It fetches the texts for the webpage in different languages
export function fetchPageTranslations(webPageName: string, language: string, locationCode: string | undefined, setData: (data: TranslationsType) => void) {
    // Menu texts are now loaded by language + page name only, while older admin
    // pages may still provide location-specific text variants.
        let apiUrl: string = backendUrl + '/texts?lang=' + language + '&web_page=' + webPageName;

        if (locationCode && locationCode.trim().length > 0) {
            apiUrl += '&location=' + locationCode;
        }

    fetch(apiUrl, {method: 'GET', headers: {'ngrok-skip-browser-warning': 'true'}})
        .then(response => {return response.json()})
        .then(response => {setData(response)})
        .catch(error => {
            console.log('Failed to fetch the partner data', error.message)
            return null;             
        })
};
